import * as React from 'react'
import Page from 'src/shared/Page/Page'
import {withI18n, WithI18n} from 'src/core/i18n/withI18n'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import PasswordTunnel from 'src/page/ValidationTunnel/PasswordTunnel'
import ProfileCheck from 'src/page/ValidationTunnel/ProfileCheck'
import {RootState} from 'src/core/redux/reducer'
import {connect} from 'react-redux'
import {IUser} from 'src/type/user'
import {updateAccountInfos, updatePassword} from 'src/core/redux/action/accountInfosAction'
import {WithToast} from 'src/type/lib/withToast'
import {RouteComponentProps, withRouter} from 'react-router'
import {Theme, WithStyles} from '@material-ui/core'
import createStyles from '@material-ui/core/styles/createStyles'
import withStyles from '@material-ui/core/styles/withStyles'
import * as moment from 'moment'
import {withToast} from 'src/shared/Toast'
import { ExpensionStep, ExpensionStepper, ExpensionStepProps } from 'src/shared/ExpensionStepper'
import { HelmetMeta } from 'src/shared/HelmetTitle/HelmetMeta'

const styles = (t: Theme) => createStyles({
  tunnelWpr:{
    marginTop: '48px'
  },
  successContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  icon: {
    color: 'green',
    fontSize: 50
  }
});

interface IProps extends ExpensionStepProps,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props>,
  WithToast,
  WithI18n,
  WithStyles<typeof styles>,
  RouteComponentProps<any>{
}

interface IState {
  newPassword: object | null;
  user: IUser | null
}

class ValidationTunnel extends React.Component<IProps, IState>{

  state = {
    newPassword: null,
    user: null
  };

  render(){
    const { t, user, classes } = this.props;
    return (
      <div className={classes.tunnelWpr}>
        <HelmetMeta title={t.App_title_page_TunnelValidation}/>
        <Page withHead>
          {(user && !user.last_password_update) &&
          <ExpensionStepper
            // position={1}
            onNext={this.onNext}
          >
            <ExpensionStep
              index={0}
              label={t.Page_Reset_password_title}
              component={<PasswordTunnel
                onSubmit={this.submitPassword}
                inTunnel={true}
              />}
            />
            <ExpensionStep
              index={1}
              label={t.Tunnel_Profile_check_title}
              component={(user && user.id) ? <ProfileCheck
                initialValues={user}
                onSubmit={this.submitProfile}
              /> : <></>}
            />
          </ExpensionStepper>
          }

        </Page>
      </div>
    )
  }

  @autobind
  private onNext(i,d){
    if(d){
      switch(i){
        case 0:
          this.setState({
            newPassword: {
              new_password: d.new_password
            }
          });
          return;
        case 1:
          this.setState({
            user: d
          }, this.endTunnel);
          return;
        default:
          return;
      }
    }
  }

  @autobind
  private endTunnel(){
    const { t } = this.props;
    this.props.updateUser(this.state.user).then(() => {
      this.props.changePassword(this.state.newPassword).then(() => {
        this.props.toastSuccess(t.Tunnel_end_toast);
        this.props.history.push('/');
      });
    });
  }

  @autobind
  private submitPassword(values){
    this.onNext(0, values)
  }

  @autobind submitProfile(values){
    values.birthday = moment(values.birthday).toISOString()
    this.onNext(1, values);
  }

}

const state2props = (state: RootState) => ({
  user: state.accountInfo.connectedUser
});

const dispatch2props = dispatch => ({
  updateUser: (data) => dispatch(updateAccountInfos(data)),
  changePassword: (pwd) => dispatch(updatePassword(pwd))
});

export default compose(
  withI18n,
  withToast,
  connect(state2props, dispatch2props),
  withStyles(styles),
  withRouter
)(ValidationTunnel);



// WEBPACK FOOTER //
// ./src/page/ValidationTunnel/ValidationTunnel.tsx